<h1 mat-dialog-title>{{data.name}}</h1>
<div class="content-box" mat-dialog-content>
  <pre>
    {{data.log}}
  </pre>
</div>
<div mat-dialog-actions>
  <button [mat-dialog-close] mat-button>Ok</button>
</div>



